<template>
    <div class="text-center">
        
        <v-row>
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
				<v-card-actions>
					<div style="width: 100%; text-align: center;">
                        <v-tooltip top v-if="showButtons.cancel">
                            <template v-slot:activator="{ on }" v-if="showButtons.cancel">
                                <v-btn 
                                    v-if="showButtons.cancel"
                                    class="mx-2"
                                    v-on="on"
                                    @click="cancel"
                                    style="background-color: var(--color__red) !important; color: #ffffff !important"
                                >
                                    Cancel
                                </v-btn>
                            </template>
                            <span>Cancel</span>
                        </v-tooltip>

                        <v-tooltip top v-if="showButtons.save">
                            <template v-slot:activator="{ on }" v-if="showButtons.save">
                                <v-btn  
                                    v-if="showButtons.save"
                                    class="mx-2"
                                    v-on="on"
                                    :loading="loading"
                                    @click="save(request)"
                                >
                                    Save
                                </v-btn>
                            </template>
                            <span>Save</span>
                        </v-tooltip>
                        <v-tooltip v-if="showButtons.close" top>
                            <template v-slot:activator="{ on }" v-if="showButtons.close">
                                <v-btn
                                    v-if="showButtons.close"
                                    class="mx-2"
                                    v-on="on"
                                    :loading="loading"
                                    @click="$emit('close')"
                                    style="background-color: var(--color__alert) !important; color: #ffffff !important"
                                >
                                    Close Work Order
                                </v-btn>
                            </template>
                            <span>Close Work Order</span>
                        </v-tooltip>
					</div>
				</v-card-actions>
            </v-col>
        </v-row>
    </div>
</template>

<script>

    export default {

        props: {
            request: {
                type: Object,
                default: null
            },

            showButtons: {
                type: Object,
                cancel: true,
                save: true
            },

            loading: {
                default: false
            }
        },

        methods: {

            cancel() {
                this.$emit("cancel");
            },

            save(request) {
                this.$emit("save", request);
            }
        }
    };
</script>

<style scoped>

    .v-btn {
        height: 45px !important;
        width: 150px;
    }

</style>
